<div class="checkin-popup-background">
	<div class="checkin-popup g-max-width">
		<p class="checkin-popup__text">{{ text[template] }}</p>
		<button>
			<img class="checkin-popup__icon" src="assets/icons/icone-fechar.svg" />
		</button>
	</div>
</div>
